var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"p-2 pb-4 sm:pb-2 lg:px-6"},[_c('router-link',_vm._b({staticClass:"inline-block duration-150 underline-from-center"},'router-link',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }